import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseSingleSelect, media } from "@helium10/re-ui-components";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { Label, StyledInputErrorMessage } from "../Styles";
export const LabeledSelect = ({ appendTo, label, value, error, options, placeholder, disabled, onChange, }) => {
    const [search, setSearch] = useState("");
    const filteredOptions = useMemo(() => options?.filter((option) => option?.searchString?.includes(search?.toLowerCase())), [options, search]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const handleChange = useCallback((e) => onChange?.(e?.value), [onChange]);
    return (_jsxs(Select, { children: [_jsx(Label, { children: label }), _jsx(BaseSingleSelect, { size: "200", autocomplete: true, dropdownAutoWidth: true, appendTo: appendTo, value: value, error: !!error, disabled: disabled, options: filteredOptions, placeholder: placeholder, onChange: handleChange, onSearch: setSearch }), error && _jsx(StyledInputErrorMessage, { children: error })] }));
};
const Select = styled.div `
  flex: 1;
  display: inline-flex;
  flex-direction: column;

  ${media.desktop} {
    max-width: 230px;
  }
`;
